module.exports = require("react-dev-utils/InlineChunkHtmlPlugin");